<div class="stepper-container" [ngClass]="openForm">
  <button class="step" [ngClass]="{'active-step': activeStep == index, 'center': centerText,'active-Blue':activeBlue}"
    *ngFor="let step of steps; index as index" (click)="stepClick(index)"
    [disabled]="index!=0 && !steps[index-1].completed">
    <span *ngIf="!hideStepNumber" class="step-number"> 
      <span >
        {{index + 1}}
      </span>
     </span>
    <span class="step-name">{{step.label}}</span>
    <img *ngIf="hasError(index)" [title]="formError" class="ml-10" src="assets/warning-circle.svg" />
    <div class="line" *ngIf="index!=steps.length-1 && line"></div>
  </button>
</div>
